<template>
  <div>
    <SearchField :form="formInline" :formCtrl="formCtrl" @onSearch="onSearch" @onReset="onReset"></SearchField>

    <div class="table-wrap">
      <el-table :data="tableData" stripe border
        :header-cell-style="{ 'background-color': '#E8ECEF', 'color': '#333', 'height': '59px' }" style="width: 100%">
        <el-table-column v-for="(c, i) in cols" :key="i" :prop="c.prop" :label="c.label" :width="c.width"
          :align="c.align || 'center'" :sortable="c.sortable">
        </el-table-column>
        <el-table-column v-if="btns" :width="'180px'" align="center" label="操作">
          <template #default="scope">
            <Btn v-for="(n, j) in btns" :key="`btn${j}`" :config="n" :data="scope.row" />

            <Btn v-if="scope.row.applystate == 1 && scope.row.isonboarding == 1 && [2, 3, 4].includes(user.user_group_id)"
              :config="btnEntry" :data="scope.row" />
          </template>
        </el-table-column>
      </el-table>

      <Pagination v-if="page && limit && total" :currentPage="page" :pageSize="limit" :total="total" :showIndex="true"
        @onSizeChange="onSizeChange" @onCurrentChange="onCurrentChange" />
    </div>

    <FormDialog ref="dialog" :title="title" :labelWidth="'110px'" :form="mform" :formCtrl="mformCtrl"
      @onModalSubmit="onModalSubmit"></FormDialog>
  </div>
</template>

<script>
import tableMixin from "../mixin/table";

export default {
  mixins: [tableMixin],
  data() {
    return {
      baseUrl: 'applypc',
      formInline: { isaudit: 2 },
      formCtrl: [
        {
          label: '提交人：',
          keyName: "applyname",
          placeholder: "请填写搜索内容",
          type: "text",
        },
      ],
      cols: [
        { prop: "title", label: "标题" },
        { prop: "applyname", label: "提交人" },
      ],
      btns: [
        {
          ...this.viewBtn,
          cb: ({ id }) => {
            this.$router.push(
              `/matterReview/detail?id=${id}`
            );
          },
        },
      ],
      btnEntry: {
        title: '入职',
        cb: ({ id, name, positionname, applyname }) => {
          this.mform = { id, name, positionname, applyname }
          this.showDialog()
        },
      },
      baseParams: ['isaudit'],
      title: '编辑详情',
      mform: {},
      mformCtrl: [
        {
          label: "姓名",
          keyName: "name",
          err: "请填写姓名",
          type: "text",
        },
        {
          label: "职位",
          keyName: "positionname",
          err: "请填写职位",
          type: "text",
        },
        {
          label: "申请人",
          keyName: "applyname",
          err: "请填写申请人",
          type: "text",
        },
        {
          label: "账号",
          keyName: "acount",
          err: "请填写账号",
          type: "text",
        },
        {
          label: "密码",
          keyName: "password",
          err: "请填写密码",
          type: "text",
        },
      ],
    };
  },
  methods: {
    onModalSubmit(data) {
      // console.log({ ...data })
      // console.log({ ...this.mform })
      this.loading = true
      let url = `${this.baseUrl}/onboarding`;
      const params = {
        ...data,
      }
      this.post(url, params, ({ msg }) => {
        if (msg === 'success') {
          this.$message({
            type: 'success',
            message: '提交成功!',
          });
          this.getList()
          this.hideDialog()
        } else {
          this.$message({
            type: 'error',
            message: msg,
          });
        }
        this.loading = false
      }, err => {
        console.log(err)
        this.$message({
          type: 'error',
          message: '提交失败，请稍后重试！'
        });
      })
    },
  },
  mounted() {
    this.getList();
  },
};
</script>

<style lang="less" scoped>
.table-wrap {
  /deep/ .el-table {
    .el-switch {
      &.inactive {
        .el-switch__core::after {
          content: '否';
          line-height: 17px;
          text-indent: 18px;
          color: #fff;
        }
      }

      &.active {
        .el-switch__core::after {
          content: '是';
          line-height: 17px;
          text-indent: -34px;
          color: #fff;
        }
      }
    }

    .overTime {
      width: 14px;
      height: 14px;
      border-radius: 100%;
      display: inline-block;
      vertical-align: top;
      margin-top: 7px;
      background: #ffe100;

      &.type1 {
        background: #98e098;
      }

      &.type2 {
        background: #fd5b5b;
      }
    }
  }
}

/deep/ .el-button.is-circle {
  padding: 5px;
  color: #96999f;
  background: #f2f6fc;
}
</style>
